import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 38 38"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M16.031 7a3.233 3.233 0 0 0-3.228 3.23c0 1.155.614 2.162 1.527 2.733a.364.364 0 0 0-.021.185l1.353 7.88a.37.37 0 0 0 .17.251c.09.058.2.073.3.045l6.12-1.697 5.027 5.639a.377.377 0 0 0 .504.05l1.938-1.425a.376.376 0 0 0-.446-.606l-1.662 1.227-4.957-5.559a.373.373 0 0 0-.38-.111l-5.944 1.648-.752-4.379h4.211a.375.375 0 0 0 0-.75h-4.34l-.355-2.054c.298.09.607.154.935.154 1.781 0 3.23-1.45 3.23-3.23A3.234 3.234 0 0 0 16.031 7zm0 .75a2.483 2.483 0 0 1 2.48 2.48 2.483 2.483 0 0 1-2.48 2.48 2.481 2.481 0 0 1 0-4.96zm-3.457 7.264a.365.365 0 0 0-.142.039A7.998 7.998 0 0 0 8 22.234c0 4.43 3.602 8.032 8.031 8.032a8.016 8.016 0 0 0 7.795-6.082.376.376 0 0 0-.273-.455.382.382 0 0 0-.455.273 7.266 7.266 0 0 1-7.067 5.514c-4.015 0-7.281-3.266-7.281-7.282a7.251 7.251 0 0 1 4.018-6.511.374.374 0 0 0-.194-.71z"
    }, null, -1)
  ])))
}
export default { render };